import { Form, FormInstance, Input } from "antd";
import CloseIcon from "../../../../../assets/icons/CloseIcon";
import MultipleChoiceInputIcon from "../_icons/MultipleChoiceInputIcon";
import { QuestionTypeProps } from "../_types/type";

export default function MultipleChoiceField({ index, form, name }: QuestionTypeProps& { form: FormInstance<any>; name: string }) {
  return (
    <Form.List name={[index, "question_choices"]} initialValue={["Option 1"]}>
      {(choices, { add, remove }) => (
        <>
          {choices.map((choiceField, idx) => (
            <div key={choiceField.key} className="flex items-center gap-2 mt-4">
              <MultipleChoiceInputIcon />
              <Form.Item
                name={[choiceField.name]}
                className="flex-1 mb-0"
                rules={[
                  {
                    required: true,
                    message: "Option is required",
                  },
                  {
                    validator: (_, value) => {
                      const options =
                        form.getFieldValue([name, index, "question_choices"]) || [];

                      const currentIndex = Array.isArray(choiceField.name)
                        ? choiceField.name[choiceField.name.length - 1]
                        : choiceField.name;

                      const duplicate = options.filter(
                        (opt: string, i: number) =>
                          opt === value && i !== currentIndex,
                      );

                      if (duplicate.length > 0) {
                        return Promise.reject("Duplicate option not allowed");
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  placeholder={`Option ${idx + 1}`}
                  className="!border-x-0 !border-t-0 !rounded-none !border-b-light !shadow-none"
                />
              </Form.Item>
              {choices?.length > 1 && (
                <span
                  onClick={() => remove(choiceField.name)}
                  className="text-status-dark-text cursor-pointer"
                >
                  <CloseIcon />
                </span>
              )}
            </div>
          ))}
          <div className="flex items-center gap-2 mt-4">
            <MultipleChoiceInputIcon />
            <div className="text-sm font-medium text-display-dark pl-2">
              Add option or{" "}
              <button
                className="text-primary"
                onClick={() => add()}
                type="button"
              >
                add “More”
              </button>
            </div>
          </div>
        </>
      )}
    </Form.List>
  );
}
